import React, { useEffect, useState } from "react";
import { toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../api/baseurl";
import { Modal, Button } from "react-bootstrap";
import "./Spinner.css";
import { useNavigate } from "react-router";
import { MdDeleteForever } from "react-icons/md";

const UploadPemeReport = ({ isOpen, onRequestClose, pemeAppointmentId }) => {
  const [report, setReport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const getData = async () => {
      const token = JSON.parse(localStorage.getItem("data")).token;
      setLoading(true);
      try {
        const searchUrl = `/api/peme-appointment-reports/pemeAppointmentId=${pemeAppointmentId}`;
        const response = await axios.get(searchUrl, {
          headers: { Authorization: `Bearer ${token}` },
        });
        
        setReport(response.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        handleError(error);
      }
    };
  

  useEffect(() => {
   getData();
  }, []);

  // Helper: convert File to base64 string
  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // Remove the data:...;base64, prefix — backend expects raw base64
        const base64 = reader.result.split(",")[1];
        resolve(base64);
      };
      reader.onerror = (error) => reject(error);
    });

  const handleViewReport = (reportId) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    const url = `/api/peme-appointment-reports/view/${reportId}`;
    axios({
      url,
      method: "GET",
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      const contentType = response.headers["content-type"] || "application/octet-stream";
      const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      window.open(blobUrl, "_blank");
    }).catch(() => toast.error("Failed to view report."));
  };

  const handleDeleteExistingReport = async (existingFile) => {
    if (!window.confirm("Are you sure you want to delete this report?")) return;
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;
    try {
      await axios.delete("/api/peme-appointment-reports", {
        headers: { Authorization: `Bearer ${token}` },
        data: existingFile
      });
      toast.success("Report deleted successfully");
      getData();
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedFiles.length === 0) {
      toast.error("Please select at least one file");
      return;
    }

    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;

    try {
      // Build list of PemeAppointmentReportEntity objects
      const entities = await Promise.all(
        selectedFiles.map(async (file) => {
          const base64 = await fileToBase64(file);
          return {
            file: base64,
            fileSize: file.size,
            fileContentType: file.type,
            fileName: file.name,
            appointmentId: pemeAppointmentId, // The prop passed to this component
          };
        })
      );

      const response = await axios.post(
        "/api/peme-appointment-reports/upload-report",
        entities,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Reports uploaded successfully");
      console.log(response.data);
      setLoading(false);
      onRequestClose();
      setSelectedFiles([]);
      setReport([]);
      getData();
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };
  

  const navigate = useNavigate();
  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      }  else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      }
       else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const handlePdfFileChange = (e) => {
    const newFiles = Array.from(e.target.files);
    
    setSelectedFiles((prevFiles) => {
      // Create array of unique files to avoid duplicates
      const updatedFiles = [...prevFiles];
      newFiles.forEach(newFile => {
        if (!updatedFiles.some(f => f.name === newFile.name && f.size === newFile.size)) {
          updatedFiles.push(newFile);
        }
      });
      
      // Sync the file input to show all files natively
      const dataTransfer = new DataTransfer();
      updatedFiles.forEach(file => dataTransfer.items.add(file));
      e.target.files = dataTransfer.files;
      
      return updatedFiles;
    });
  };

  const removeFile = (index) => {
    setSelectedFiles((prevFiles) => {
      const updatedFiles = prevFiles.filter((_, i) => i !== index);
      
      // Update the file input to match
      const fileInput = document.getElementById("file");
      if (fileInput) {
        const dataTransfer = new DataTransfer();
        updatedFiles.forEach(file => dataTransfer.items.add(file));
        fileInput.files = dataTransfer.files;
      }
      
      return updatedFiles;
    });
  };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered >
      <Modal.Header closeButton>
      {loading && <div className="loading"></div>}
        <Modal.Title>Upload PEME Report</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      {loading && <div className="loading"></div>} 
        <div className="col-xl-10 mx-xl-auto">
          <div className="card card-raised mb-3">
            <div className="card-body p-4 ">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="file" className="form-label" style={{ fontWeight: "500" }}>
                    Upload Files:<span style={{color:"red"}}>*</span>
                  </label>
                  <input
                    className="form-control"
                    id="file"
                    type="file"
                    onChange={handlePdfFileChange}
                    multiple
                  />
                </div>

                {report && report.length > 0 && (
                  <div className="mb-4">
                    <label style={{ fontWeight: "500", display: "block" }} className="form-label">
                      Already Uploaded Reports:
                    </label>
                    <ul className="list-group">
                      {report.map((existingFile, ri) => (
                        <li key={existingFile.id} className="list-group-item d-flex justify-content-between align-items-center">
                          <span
                            style={{cursor:'pointer', color:'#0d6efd', textDecoration:'underline'}}
                            onClick={() => handleViewReport(existingFile.id)}
                            title={existingFile.fileName || `File ${ri + 1}`}
                          >
                            {existingFile.fileName || `File ${ri + 1}`}
                          </span>
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => handleDeleteExistingReport(existingFile)}
                            title="Delete File"
                          >
                            <MdDeleteForever size={20} />
                          </Button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {selectedFiles.length > 0 && (
                  <div className="mt-3">
                    <h6>Selected Files:</h6>
                    <ul className="list-group">
                      {selectedFiles.map((file, index) => (
                        <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                          {file.name}
                          <Button variant="danger" size="sm" onClick={() => removeFile(index)} title="Remove">
                            <MdDeleteForever size={20} />
                          </Button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                <div className="d-flex justify-content-center mt-4 gap-3">
                  <Button variant="dark" className="px-4" style={{ fontWeight: "bold", minWidth: "120px" }} onClick={onRequestClose}>
                    CLOSE
                  </Button>
                  <input
                    type="submit"
                    value="SAVE"
                    className="btn btn-dark px-4"
                    style={{ fontWeight: "bold", minWidth: "120px" }}
                    disabled={loading || selectedFiles.length === 0}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

export default UploadPemeReport;
